import { ViewModel,View, ObservableArray } from "binder"
import  { SearchableSelectorBaseView } from "./searchableSelectorBase-view"
import { translate } from "src/common/utilities";

export type ElementType = {
    set title(v: string);
    get title(): string;
    set id(v: string);
    get id(): string;
};


export abstract class SearchableSelectorBaseViewModel<T extends ElementType & ViewModel> extends ViewModel{
    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.placeholder = translate("searchableSelectorBase-viewModel.searchWithEnter",{});
        this.searchFunction = (ids,searchTerm)=>{return this.loadData(searchTerm)};
    }

    GetDefaultView(): View <ViewModel> {
        return new SearchableSelectorBaseView();
    }
    public getTypeId(): string {
        return "VM-1EFF89D3-47BC-4D49-BE3E-706356BEC01E"
    }

    

    public set selectedItem(v: T) { 
        this._selectedItem = v;
        this.onSelectionChanged(v);
    } public get selectedItem(): T { return this._selectedItem;} private _selectedItem: T;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    public set placeholder(v: string) { this._placeholder = v; } public get placeholder(): string { return this._placeholder;} private _placeholder: string;
    public set searchFunction(v: (ids:string[],searchTerm:string)=>Promise<ViewModel[]>) { this._searchFunction = v; } public get searchFunction(): (ids:string[],searchTerm:string)=>Promise<ViewModel[]> { return this._searchFunction;} private _searchFunction: (ids:string[],searchTerm:string)=>Promise<ViewModel[]>;
    
    public async selectById(id:string){
        if(id==null){
            this.selectedItem = null;
        }else{
            try {
                this.isLoading = true;
                let result = await this.loadById(id);
                if(result==null){
                    this.selectedItem = null;
                }else{
                    this.selectedItem = result;
                }
            } catch (ex) {
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
    protected abstract loadData(searchedText:string):Promise<T[]>; 
    protected abstract loadById(id:string):Promise<T>;

    async refresh(){

    }
    onSelectionChanged(element:T){};
}
